import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'

function Payments() {
  const [loading, setLoading] = useState(true)
  return (
    <div style={{width:"100%",height:"100vh",display:"flex",justifyContent:"center",alignItems:"center"}}>
      {loading ? <div style={{margin:"auto",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"5px"}}>

        <img src='https://b2161880.smushcdn.com/2161880/wp-content/uploads/2018/06/bank-3487033_1920.png?lossy=1&strip=1&webp=1' width="200px" height="150px"/>
        <h3>No saved cards</h3>
        <p>We have thousands of items available across our wide range of sellers. Start ordering today!</p>
        <button style={{backgroundColor:"blueviolet",border:"none",borderRadius:"5px",color:"white",padding:"10px 20px"}}>Start Shopping</button>
      </div>:<>
      
      </>}
    </div>
  )
}

export default Payments